import moment from 'moment'
import ProjectService from '@/services/ProjectService'

const state = {
  edit: null,
  data: [],
  preview: null
}

const mutations = {
  SET_DATA (state, data) {
    state.data = data
  },
  SET_EDIT (state, edit) {
    state.edit = edit
  },
  SET_PREVIEW (state, preview) {
    state.preview = preview
  },
  STORE (state, data) {
    state.data.push(data)
  },
  UPDATE (state, link) {
    state.data = state.data.map(_link => {
      return link.id === _link.id ? link : _link
    })
  },
  DESTROY (state, link) {
    state.data = state.data.filter(_link => {
      return link.id !== _link.id
    })

    if (state.data[0]) {
      state.id = state.data[0].id
    }
  }
}

const actions = {
  async index ({ commit }, project_id) {
    const data = await ProjectService.index(`/${project_id}/links?start_at=${moment().subtract(7, 'days').utc().format('YYYY-MM-DD [00:00]')}`)
    commit('SET_DATA', data)
    return data
  },
  async show (_, { project_id, id }) {
    return ProjectService.show(`/${project_id}/links/${id}`)
  },
  async store ({ commit }, { project_id, data }) {
    const store = await ProjectService.store(`/${project_id}/links`, data)
    commit('STORE', store)
    return store
  },
  async storePreview ({ commit, state, rootState }) {
    if (!state.preview || !rootState.auth.user || !rootState.auth.user.accepted_terms) {
      return false
    }

    try {
      const store = await ProjectService.store(`/${rootState.projects.id}/links`, state.preview)
      commit('STORE', store)
      commit('SET_PREVIEW', null)

      return store
    } catch (e) {
      alert(e.message)
    }
  },
  async update ({ commit }, { project_id, id, data }) {
    const update = await ProjectService.update(`/${project_id}/links/${id}`, data)
    commit('UPDATE', update)
    return update
  },
  async destroy ({ commit }, { project_id, id }) {
    const destroy = await ProjectService.destroy(`/${project_id}/links/${id}`)
    commit('DESTROY', destroy)
    return destroy
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
